export function isMobile() {
  return window.matchMedia('(max-width: 991.98px)').matches;
}

export function getNumberId(id) {
  return String(id).replace(/gid:\/\/shopify\/.+?\/(\d+)/, '$1');
}

export function formatPrice(price) {
  return price.toLocaleString('ja-JP', { style: 'currency', currency: 'JPY' });
}

export async function fetchSnap(params) {
  const endpoint = 'https://www.fashionsnap.com/api/store/articles/';
  const searchParams = new URLSearchParams(params || {}).toString();
  const url = `${endpoint}${searchParams && '?'.concat(searchParams)}`;
  return fetch(url).then((response) => response.json());
}
